import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { debounce } from 'lodash'
import { getGlobalParams, getCustomIntl } from 'config/config'
import { isMobile, isTouchDevice } from 'utils/check-device'
import { Button, CheckboxGroup } from 'gdpp-components/dist/cjs/components/atoms'
import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import Input from '../../atoms/Input'
import Tooltip from '../../atoms/Tooltip'
import List from '../../atoms/List'
import Modal from '../Modal'

import './style.scss'
import FilterSelect from './FilterSelect'

const FilterGenerator = ({ filterData, common, isMoreButton, isMoreFilter, moreFilterFunc, updateFilterData }) => {
  const { terms: globalTerms } = getGlobalParams()
  const intl = getCustomIntl()
  const { terms } = common
  const { expand, shrink, placeholderSelected, placeholderUnselected } = terms

  const [currentFilterData, setCurrentFilterData] = useState()

  const handleFilterChange = (info) => {
    setTimeout(() => {
      updateFilterData(info)
    }, 0)
  }

  useEffect(() => {
    setCurrentFilterData(filterData)
  }, [filterData])

  return (
    <React.Fragment>
      {currentFilterData ? (
        <Grid extraClasses={classnames('fund-filter__section', currentFilterData.extraClasses)}>
          {currentFilterData.elements.map((component) => {
            const onChangeProps =
              isMobile() || isTouchDevice()
                ? {
                    onChange: debounce((e) => handleFilterChange({ type: 'input', id: component.key, value: e.value }), 500)
                  }
                : {
                    onKeyup: debounce((e) => handleFilterChange({ type: 'input', id: component.key, value: e.value }), 500)
                  }
            return (
              <Cell extraClasses={classnames('fund-filter__item', component.extraClasses)} key={component.key}>
                {component.type === 'input' && (
                  <>
                    <label id={`fil-fund-filter__label-${component.label}`} className="fund-filter__label show-for-large">
                      {component.label}
                    </label>
                    <Input
                      id={component.key}
                      name="funds-search-box"
                      layout=""
                      value={component.value}
                      placeholder={component.placeholder}
                      {...onChangeProps}
                      icon="search"
                    />
                  </>
                )}
                {component.type === 'check' && (
                  <CheckboxGroup
                    id={component.key}
                    label={component.label}
                    options={component.options}
                    onChange={(childLabel, value) => handleFilterChange({ type: 'check', id: component.key, label: childLabel, value })}
                  />
                )}
                {component.type === 'select' && (
                  <FilterSelect
                    id={component.id || component.key}
                    placeholder={placeholderUnselected}
                    selectedText={placeholderSelected}
                    // label={component.label}
                    options={component.options}
                    value={component.value}
                    // tooltip={component.tooltip}
                    onChange={(e) => handleFilterChange({ type: 'select', id: component.key, value: e.value })}
                    {...(component.label ? { label: component.label } : {})}
                    {...(component.tooltip
                      ? {
                          tooltip: (
                            <div className="fund-filter__label-select-tooltip">
                              {component.tooltip === 'tooltip' && <Tooltip message={component.tooltip} />}
                              {component.tooltip === 'modalTooltip' && (
                                <Modal
                                  {...{
                                    modalHeader: intl.formatMessage({ id: 'fundDetail.riskRatingModal.title' }),
                                    extraClasses: 'fil-general-info__risk-morningstar-modal',
                                    size: 'small',
                                    zIndex: 100,
                                    kind: 'tooltip'
                                  }}
                                >
                                  <div>
                                    <List contents={globalTerms.fundDetail.riskRatingModal.modalList} />
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: intl.formatMessage({ id: 'fundDetail.riskRatingModal.content' })
                                      }}
                                    />
                                  </div>
                                </Modal>
                              )}
                            </div>
                          )
                        }
                      : {})}
                  />
                )}
              </Cell>
            )
          })}
          {isMoreButton && (
            <Cell id="fil-fund-filter__more" extraClasses="large-1 filter__item fund-filter__more">
              <Button
                kind="textlink"
                icon={isMoreFilter ? 'custom-chevron-up' : 'custom-chevron-down'}
                iconPosition="right"
                iconSize="16"
                label={isMoreFilter ? shrink : expand}
                extraClasses=""
                onClick={moreFilterFunc}
              />
            </Cell>
          )}
        </Grid>
      ) : null}
    </React.Fragment>
  )
}

FilterGenerator.propTypes = {
  filterData: PropTypes.object.isRequired,
  common: PropTypes.object.isRequired,
  isMoreButton: PropTypes.bool,
  isMoreFilter: PropTypes.bool,
  moreFilterFunc: PropTypes.func,
  updateFilterData: PropTypes.func.isRequired
}

FilterGenerator.defaultProps = {
  isMoreButton: false,
  isMoreFilter: false,
  moreFilterFunc: () => {}
}

export default FilterGenerator
